<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateUniversity)">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>account_balance</md-icon>
          </div>
          <h4 class="title">Candidate Form Status - <small>Update</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider name="status" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Status</label>
                  <md-select v-model="status" name="type">
                    <md-option value="">Select Degree</md-option>
                    <md-option value="10">New Form</md-option>
                    <md-option value="20">In Progress</md-option>
                    <md-option value="30">Possible</md-option>
                    <md-option value="40">Applied</md-option>
                    <md-option value="50">Dropped</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider name="result" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>Result</label>
                  <md-input v-model="result" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider name="note" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>Note</label>
                  <md-input v-model="note" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success mt-4"
                >Update Status
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, numeric, email } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);
extend("email", email);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    },
    avatar: {
      type: String,
      default: "/img/image_placeholder.jpg"
    }
  },
  data() {
    return {
      candidateID: null,

      status: null,
      result: null,
      note: null
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    updateUniversity() {
      let data = {
        status: this.status,
        result: this.result,
        note: this.note
      };
      var post_data = {};
      for (const field in data) {
        if (data[field] instanceof Date) {
          post_data[field] = data[field]
            .toLocaleDateString("ko-KR")
            .replaceAll(". ", "-")
            .replaceAll(".", "");
        } else {
          if (field === "discounted_price" && data[field] === "") {
            post_data[field] = null;
          } else {
            post_data[field] = data[field];
          }
        }
      }
      this.$store
        .updateCandidateStatus(post_data, this.candidateID)
        .then(response => {
          this.$notify({
            message: "Candidate Form status updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    }
  },
  mounted() {
    this.candidateID = this.$route.params.id;
  }
};
</script>
<style>
.picture input[type="file"] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
